module.exports = __webpack_public_path__ + "static/media/first.7c75c4bd.png";